import React from "react";
import { Box, Avatar, Typography } from "@mui/material";

const Card17ImageTextTime = ({ card, handleProfileClick }) => (
  <Box sx={{ marginBottom: 2 }}>
    {card.cardMetaData?.title && (
      <Typography
        variant="h6"
        sx={{
          marginBottom: 1,
          fontWeight: "bold",
          textAlign: "left",
          color: "#771615",
          fontSize: "16px",
        }}
      >
        {card.cardMetaData.title}
      </Typography>
    )}
    <Box
      sx={{
        display: "flex",
        gap: 2,
        overflowX: "auto",
        padding: "8px 0",
      }}
    >
      {card.cardData.map((item, idx) => (
        <Box
          key={idx}
          onClick={() => handleProfileClick(item.data)} // Navigate to StreamerProfile
          sx={{
            textAlign: "center",
            flexShrink: 0,
            width: 70,
            cursor: "pointer", // Make clickable
          }}
        >
          <Avatar
            src={item.data.imageUrl}
            alt={item.data.displayName}
            sx={{
              width: 60,
              height: 60,
              margin: "0 auto",
              marginBottom: "4px",
              border: "2px solid #ddd",
            }}
          />
          <Typography
            variant="body2"
            sx={{
              fontWeight: "bold",
              color: "#333",
              fontSize: "12px",
              overflow: "hidden",
              whiteSpace: "nowrap",
              textOverflow: "ellipsis",
              maxWidth: "70px",
            }}
          >
            {item.data.displayName}
          </Typography>
        </Box>
      ))}
    </Box>
  </Box>
);

export default Card17ImageTextTime;